var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#20A160",
    fillOpacity: 0.13
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#20A160",
    strokeOpacity: 0.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6307 12.0745C14.8282 11.0892 16.3472 10.5 18 10.5C19.6528 10.5 21.1718 11.0892 22.3693 12.0745L23.4997 10.9118L24.5997 12.0431L23.4693 13.2058C24.4272 14.4376 25 16 25 17.7V18.5H11V17.7C11 16 11.5728 14.4376 12.5307 13.2058L11.4003 12.0431L12.5003 10.9118L13.6307 12.0745ZM11 20.1H25V25.7C25 26.1418 24.6518 26.5 24.2222 26.5H11.7778C11.3482 26.5 11 26.1418 11 25.7V20.1ZM15.6667 16.1C16.0962 16.1 16.4444 15.7418 16.4444 15.3C16.4444 14.8582 16.0962 14.5 15.6667 14.5C15.2371 14.5 14.8889 14.8582 14.8889 15.3C14.8889 15.7418 15.2371 16.1 15.6667 16.1ZM20.3333 16.1C20.7629 16.1 21.1111 15.7418 21.1111 15.3C21.1111 14.8582 20.7629 14.5 20.3333 14.5C19.9038 14.5 19.5556 14.8582 19.5556 15.3C19.5556 15.7418 19.9038 16.1 20.3333 16.1Z",
    fill: "#20A160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidDeviceIcon);
export default __webpack_public_path__ + "static/media/androidDeviceIcon.88f6b569.svg";
export { ForwardRef as ReactComponent };